import AudioManager from '@play-co/timestep-core/lib/AudioManager';
import soundConfig from 'src/conf/soundConfig';

type SFX = keyof typeof soundConfig.sfx;
type Music = keyof typeof soundConfig.music;

class Sounds {
  public music: AudioManager;
  public sfx: AudioManager;

  public playingSong: Music | '' = '';

  private _musicMuted = false;
  private _sfxMuted = false;
  private _musicVolume = 1;
  private _sfxVolume = 1;

  constructor() {
    this.music = new AudioManager({
      path: soundConfig.musicPath,
      files: soundConfig.music,
    });

    this.sfx = new AudioManager({
      path: soundConfig.sfxPath,
      files: soundConfig.sfx,
    });
  }

  public setSoundTime(name: SFX, t: number) {
    this.sfx.setTime(name, t);
  }

  public playSound(name: SFX, volume = 1) {
    if (this.sfxMuted) return;

    this.sfx.setVolume(name, this._sfxVolume * volume);
    this.sfx.play(name);
  }

  public stopSound(name: SFX) {
    this.sfx.stop(name);
  }

  public playSong(name: Music) {
    if (this.playingSong === name) return;
    this.playingSong = name;
    this.music.setVolume(name, this._musicVolume);
    this.music.playBackgroundMusic(name);
  }

  public resumeSong() {
    if (this.playingSong) {
      this.playSong(this.playingSong);
    }
  }

  public pauseSong() {
    this.music.pauseBackgroundMusic();
  }

  public stopSong() {
    if (this.playingSong) {
      this.music.stop(this.playingSong);
      this.playingSong = '';
    }
  }

  public get sfxMuted() {
    return this._sfxMuted;
  }

  public set sfxMuted(value) {
    this._sfxMuted = value;
    this.sfx.setEffectsMuted(value);
  }

  public get musicMuted() {
    return this._musicMuted;
  }

  public set musicMuted(value) {
    if (value === this._musicMuted) return;
    this._musicMuted = value;
    this.music.setMusicMuted(value);
  }

  public set musicVolume(value) {
    if (value === 0) {
      this.musicMuted = true;
    } else {
      if (this._musicVolume === 0) {
        this.musicMuted = false;
      }
      this.music.setVolume(this.playingSong, this._musicVolume);
    }

    this._musicVolume = value;
  }

  public get musicVolume() {
    return this._musicVolume;
  }

  public set sfxVolume(value) {
    if (value === 0) {
      this.sfxMuted = true;
    } else if (this._sfxVolume === 0) {
      this.sfxMuted = false;
    }

    this._sfxVolume = value;
  }

  public get sfxVolume() {
    return this._sfxVolume;
  }
}

export default new Sounds();
